import { useHtzAirHandlingUnitDataShowQuery } from "@/services/backend/htz/ahu/api/ahu-data-api";
import { UUID } from "@bitory-gmbh/nidavellir";

export function AirHandlingUnitDataDesignation({ id }: { id: UUID }) {
  const { data } = useHtzAirHandlingUnitDataShowQuery({ id });

  if (!data) {
    return null;
  }

  return <span>{data.designation}</span>;
}

export function AirHandlingUnitComponentName({
  id,
  componentId,
}: {
  id: UUID;
  componentId: UUID;
}) {
  const { data } = useHtzAirHandlingUnitDataShowQuery({ id });

  if (!data) {
    return null;
  }

  const componentName = data.components.find(
    (c) => c.componentId === componentId,
  )?.name;

  return componentName ?? null;
}
